import { useNavigate } from 'react-router-dom';
import shopActions from 'services/shop/actions';
import { SHOP_DEVICE_TYPE } from 'services/shop/constants';
import { IBodyApiAddDeviceWithStation } from 'services/shop/types/station';
import { useAppDispatch } from 'store/hooks';
import storage, { getDeviceId } from 'utils/sessionStorage';
import { FeatureVerify, OTPVerificationRef } from 'widgets/OTPVerification';
import authActions from '../services/actions';
import { IShopItem } from '../services/types/owner';

const useChooseStore = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const chooseShopDevices = (shopInfo?: IShopItem | null) => {
    const shopId = shopInfo?.id;
    if (!shopId) return;
    if (!shopInfo) return;
    const callback = async () => {
      storage.shop_timezone.set(shopInfo.timeZone);
      dispatch(shopActions.get.allSetting.fetch(shopId));
      dispatch(shopActions.get.shopInfo.fetch(shopId));

      const deviceId = getDeviceId();
      const body: IBodyApiAddDeviceWithStation = {
        deviceId,
        deviceType: SHOP_DEVICE_TYPE.POS,
        stationNumber: 0,
      };
      try {
        storage.station_number.set(body.stationNumber?.toString());
        storage.device_id.set(deviceId);
        storage.shop_id.set(shopId);
        dispatch(authActions.addDeviceId({ shopId, deviceId }));
        navigate('/store/' + shopId);
      } catch (error) { }
    };
    if (OTPVerificationRef.current)
      OTPVerificationRef.current?.open(callback, FeatureVerify.LOGIN, { shopId, phone: shopInfo.phone });
    else callback();
  };

  return chooseShopDevices;
};

export default useChooseStore;
